import { getCountry } from '../iwIntlProvider/CountryProvider';

export const normalizeSortCode = (value?: string) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length <= 2) {
        return onlyNums;
    }
    if (onlyNums.length <= 4) {
        return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2)}`;
    }

    return `${onlyNums.slice(0, 2)}-${onlyNums.slice(2, 4)}-${onlyNums.slice(
        4,
        6
    )}`;
};

export const normalizeBankAccountNumber = (value: string) => {
    return value.slice(0, 8);
};

export const normalizeIBANNumber = (value: string) => {
    // length of DE IBAN
    const maxLength = 22;

    return value
        .toUpperCase()
        .replace(/[^\dA-Z]/g, '')
        .slice(0, maxLength)
        .replace(/(.{4})/g, '$1 ')
        .trim();
};

export const normalizePostcode = (value?: string) => {
    if (value === undefined || getCountry() === 'UK') return value;

    return value.replace(/[^0-9]+/g, '').slice(0, 5);
};

export function roundTwoDecimalPlaces(value: string) {
    return Math.round(Number(value) * 100) / 100;
}

export function normalizeNumbersWithGroups(value: string) {
    let valueAsDecimal;
    if (getCountry() === 'DE') {
        valueAsDecimal = value.replace(/\./g, '').replace(',', '.');
    } else {
        valueAsDecimal = value.replace(/,/g, '');
    }
    return roundTwoDecimalPlaces(valueAsDecimal);
}

export function integerToStringNumberWithIntlGroups(
    value: number,
    locale?: string
) {
    const formatSettings = {
        style: 'decimal',
        useGrouping: true,
        maximumFractionDigits: 2,
        minumumFractionDigits: 2
    };

    const formattedValue = new Intl.NumberFormat(locale, formatSettings).format(
        value
    );
    return formattedValue;
}
